











import { Vue, Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import UserProductSettings from "./UserProductSettings.vue";
import { ProductInstanceResult } from "@futuri/cloudsso-client";

@Component({
  components: {
    UserProductSettings
  }
})
export default class UserTopLine extends Vue {
  @Getter("availableInstances")
  availableInstances?: ProductInstanceResult[];

  get instances() {
    console.log("getting instances");
    return this.availableInstances ?? [];
  }

  @Getter("hasTopLine")
  hasProduct!: boolean;
}
